import type { GatewayShipmentLocale } from "@/locales/fr/gateway-shipment";

const gatewayShipmentLocale: GatewayShipmentLocale = {
  gatewayShipment: {
    request: "Gateway shipment request",
    requestHistory: {
      title: "History",
      description: "Gateway shipment requests made",
      nGatewaysSent: "{n} gateway sent | {n} gateways sent",
      requestType: "Request type",
      comment: "Comment",
    },
    noGateways: "No equipment",
    noGatewaysWarning:
      "No equipment is installed on-site. It is not possible to request gateway shipment on a site without equipment.",
    beforeShipment: "Before any shipment of equipment:",
    beforeShipmentList: [
      "Send a gateway only if necessary (after diagnosis)",
      "Verify the postal address, main phone number, and email address",
      "The equipment is shipped within 5 business days to the address provided on VoltaCall",
      "In the package, the member will find operating instructions to install the new gateway",
    ],
    form: {
      number: "Gateway shipment reason",
      rooms: "Select devices concerned by gateway shipment",
      sendCause: "Gateway shipment reason",
      sendCausePlaceholder: "Select a gateway shipment cause ...",
      gatewayModelType: "Gateway model type:",
      commentsPlaceholder: "Comment...",
      sendCauseOptions: {
        noGatewayOnSite: "No gateway on site",
        gatewayHs: "Defective gateway",
        badNetworkConnection: "Poor network connection",
        largeHouseThickWalls: "Large house / thick walls",
        other: "Other",
      },
      gatewayModelTypeOptions: {
        bouygues: "Bouygues",
        kpn: "KPN",
        noPreference: "No preference",
      },
    },
  },
};

export default gatewayShipmentLocale;
